<template>
  <v-dialog v-model="dialog" max-width="350">
    <v-card class="shadow">
      <div class="pa-4 pa-md-6">
        <h3 class="font-weight-bold mb-3">Filter Registered Players</h3>
        <v-form
          ref="form"
          @submit.prevent="do_filter"
          lazy-validation
          class="d-flex flex-column"
          style="gap: 1rem"
        >
          <v-menu
            v-model="date_from_menu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="date_from"
                label="Date From"
                hide-details="auto"
                readonly
                outlined
                dense
                v-bind="attrs"
                v-on="on"
                @keyup="date_from_menu = true"
                @keydown="date_from_menu = false"
                clearable
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="date_from"
              @input="date_from_menu = false"
            ></v-date-picker>
          </v-menu>

          <v-menu
            v-model="date_to_menu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="date_to"
                label="Date To (Optional)"
                hide-details="auto"
                readonly
                outlined
                dense
                v-bind="attrs"
                v-on="on"
                @keyup="date_to_menu = true"
                @keydown="date_to_menu = false"
                clearable
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="date_to"
              @input="date_to_menu = false"
              :min="date_from"
            ></v-date-picker>
          </v-menu>

          <v-select
            v-model="account_verified"
            :items="verification_statuses"
            label="Account Verified"
            dense
            outlined
            hide-details="auto"
          ></v-select>

          <v-select
            v-model="is_active"
            :items="active_statuses"
            label="Active Status"
            dense
            outlined
            hide-details="auto"
          ></v-select>

          <div class="d-flex justify-end bs-gap-2 mt-2">
            <v-btn text @click="close_dialog">Cancel</v-btn>
            <v-btn depressed color="primary" type="submit">Filter</v-btn>
          </div>
        </v-form>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "RegisteredPlayersFilter",
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    date_from: null,
    date_from_menu: false,
    date_to: null,
    date_to_menu: false,
    account_verified: "All",
    verification_statuses: [
      "All",
      "Pending",
      "Verified",
      "Files Submitted",
      "Rejected",
    ],
    is_active: "All",
    active_statuses: ["All", "Active", "Inactive"],
  }),
  computed: {
    dialog: {
      get: function () {
        return true;
      },
      set: function () {
        this.close_dialog();
      },
    },
  },
  mounted() {
    // Initialize with passed data
    this.date_from = this.data.date_from || null;
    this.date_to = this.data.date_to || null;
    this.account_verified = this.data.account_verified || "All";
    this.is_active = this.data.is_active || "All";
  },
  methods: {
    do_filter() {
      if (this.$refs.form.validate()) {
        this.$emit("set_close_filter_dialog", {
          type: true,
          date_from: this.date_from,
          date_to: this.date_to,
          account_verified: this.account_verified,
          is_active: this.is_active,
        });
      }
    },
    close_dialog() {
      this.$emit("set_close_filter_dialog", { type: false });
    },
  },
  watch: {
    date_from(val) {
      // Only update date_to if it exists and is before the new date_from
      if (this.date_to && new Date(val) > new Date(this.date_to)) {
        this.date_to = val;
      }
    },
  },
};
</script>
